





























































































import { Component, Vue, Prop } from "vue-property-decorator";
import { bus } from "@/bus";
// types
import { Contract, LicenceTypes, LicenceType } from "@/services/contracts/types";
import { contractFields } from "@/components/contracts/fields/contractFields";
// service methods
import { getContracts } from "@/services/contracts/contractService";
import { getSolutions, addContract, deleteContract, setSolutionType } from "@/services/solutions/solutionService";
import { Solution, SolutionTypeEnum } from "@/services/solutions/types";
// components
import SelectSolutionModal from "@/components/solutions/modals/SelectSolutioModal.vue";
import RemoveSolutionFromContractModal from "@/components/contracts/modals/SolutionDeleteModal.vue";

@Component({
    components: {
        SelectSolutionModal,
        RemoveSolutionFromContractModal
    }
})
export default class Contracts extends Vue {
    @Prop() contractId!: string;
    // local state
    contracts = [] as Contract[];
    localSolutions = [] as Solution[];
    solutions = [] as Solution[];
    fields = contractFields;
    isBusy = false;
    licenceTypes = LicenceTypes
    filterSolution = false;
    filterSolutionsDto = {
        contractId: "",
        licenceType: "",
        total: 0
    }

    activeItem = "";

    allowAddSolution = false;
    visible = false;

    // filter options
    searchQuery = "";

    // lifecycle hooks
    public created(): void {
        this.fetchData();

        bus.$on("reload", () => {
            this.fetchData();
        });
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // Watchers

    // computed
    get filteredData(): Array<Solution> {
        if (this.filterActive) {
            return this.localSolutions.filter(
                x =>
                    this.searchQuery.length === 0 ||
                    x.name.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        } else {
            return this.localSolutions;
        }
    }

    get filterActive(): boolean {
        return (this.searchQuery !== "" || this.filterSolution);
    }

    // methods
    fetchData() {
        this.loadContracts();
    }

    async loadContracts() {
        this.solutions = await getSolutions();
        this.contracts = await getContracts();
        if (this.contracts.length < 1) return;

        if (this.contractId) {
            const contract = this.contracts.find(x => x.id === this.contractId);
            if (contract) {
                const licence = Object.entries(contract.licences).find(([key, value]) => value > 0);
                if (licence) {
                    await this.filterByLicenceType(licence[0] as keyof LicenceType, contract.id, licence[1] as number, Object.keys(contract.licences).indexOf(licence[0]));
                }
            }
        } else {
            const defaultContract = this.contracts[0];
            if (defaultContract) {
                const licence = Object.entries(defaultContract.licences).find(([key, value]) => value > 0);
                if (licence) {
                    await this.filterByLicenceType(licence[0] as keyof LicenceType, defaultContract.id, licence[1] as number, Object.keys(defaultContract.licences).indexOf(licence[0]));
                }
            }
        }
    }

    async loadSolutions() {
        this.isBusy = true;
        this.solutions = await getSolutions();
        this.isBusy = false;
    }

    addSolution() {
        (this.$refs.contractAddSolutionModal as any).open(Object.keys(this.licenceTypes[this.filterSolutionsDto.licenceType as keyof LicenceType]), false, true);
    }

    async onSolutionSelected(solutions: Solution[]) {
        if (!solutions || solutions.length <= 0) return;
        const solutionsWithoutType = solutions.filter((x: any) => !x.type);
        if (solutionsWithoutType.length > 0) {
            await setSolutionType(solutions.map((x: Solution) => x.id), this.filterSolutionsDto.licenceType);
        }
        const lincenes = solutions.map((x: Solution) => {
            return {
                solutionId: x.id,
                contractId: this.filterSolutionsDto.contractId
            };
        });
        await addContract(lincenes);
        await this.filterByLicenceType(this.filterSolutionsDto.licenceType as keyof LicenceType, this.filterSolutionsDto.contractId, this.filterSolutionsDto.total);
        await this.loadSolutions();
    }

    async deleteContract(solution: Solution) {
        if (!solution) return;
        (this.$refs.removeSolution as any).open(solution);
    }

    async onRemoveSolution(solution: Solution) {
        await deleteContract(solution.id);
        await this.filterByLicenceType(this.filterSolutionsDto.licenceType as keyof LicenceType, this.filterSolutionsDto.contractId, this.filterSolutionsDto.total);
    }

    async filterByLicenceType(type: keyof LicenceType, contractId: string, total: number, index: number = -1) {
        this.filterSolutionsDto = {
            contractId: contractId,
            licenceType: type.toString(),
            total: total
        };
        await this.loadSolutions();
        this.filterSolution = true;
        this.allowAddSolution = this.getAvailableLicences(type, total, contractId) > 0;
        this.localSolutions = this.solutions.filter(x => x.contractId === contractId && Object.values(this.licenceTypes[type]).find(y => y === x.type));

        if (index !== undefined && this.activeItem !== index + contractId && index !== -1) {
            this.activeItem = index + contractId;
        }
    }

    getAvailableLicences(type: keyof LicenceType, total: number, contractId: string) {
        return total - this.solutions.filter(x => x.contractId === contractId && Object.values(this.licenceTypes[type]).find(y => y === x.type)).length;
    }

    goToSolutionRoute(id: string) {
        return {
            name: "updateSolution",
            params: { solutionId: id }
        };
    }
}
